/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function MobileDevice() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'MobileDevice',
				config: {
					ruleType: "device",
					args: {
						devices: ["mobile"],
					},
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			mobile
			devices.
		</p>
	</>;
}
